import { render, staticRenderFns } from "./SubjectsBody.vue?vue&type=template&id=6b88eacc&scoped=true"
import script from "./SubjectsBody.vue?vue&type=script&lang=js"
export * from "./SubjectsBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b88eacc",
  null
  
)

export default component.exports